// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/root/workspace/csida-rc_6PNv/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import UserOutlined from '/root/workspace/csida-rc_6PNv/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
import ProfileOutlined from '/root/workspace/csida-rc_6PNv/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ProfileOutlined';
export default { SmileOutlined, UserOutlined, ProfileOutlined };
